<template>
  <div>
    <el-table
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        v-for="(item, index) in field"
        :key="index"
        :prop="item.data"
        :label="item.label"

      >
      </el-table-column>
       <el-table-column
        fixed="right"
        label=""
        width="200"

      >
        <template #default={row}>
          <div @click="handleClick(row)">
            <img :src="imageRoot + '/social/Apply_button.png'" alt="" srcset="">
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ['tableData'],
  data () {
    return {
      field: [
        { 'label': 'Position', 'data': 'en_name' },
        { 'label': 'Location', 'data': 'en_address' }
      ],
      imageRoot: process.env.VUE_APP_IMAGE_PATH
    }
  },
  methods: {
    handleClick (row) {
      this.$router.push({ name: 'overseas', params: { typeId: row.type_id, id: row.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.el-table{
    th{
      border-bottom: 1px solid #919191;
      font-size: 16.4px;
      color: #124088;
    }
    tr{
      &:first-child{
        td{
          padding-top: 30px;
        }
      }

      td{
        line-height: 30px;
        font-size: 16.4px;
        color:#636363;
        &:first-child{
          color:#151515;
          font-family: $fontFmailyM;
        }
        &:last-child{
          cursor: pointer;
          img{
            padding-top:3px;
            @include hoverAnimation(1.06);
            width:80%;
          }
        }
        .cell{
          line-height: 20px;
        }
      }
    }
    .el-table__fixed-right{
      height:100% !important;
      margin-top:0;
    }
  }
</style>
